/**
 * Created by yan on 16-1-20.
 */
export { default as MyComponent } from './MyComponent';
// 总体框架
export { default as SiderMenu } from './SiderMenu/index';
// body框架
export { default as PageHeaderLayout } from './pageHeaderLayout/index';
// 查看大图
export { default as ReviewImage } from './reviewImage/index';
// 查看详情
export { default as DrawerDetail } from './tableDrawer/index';
// 表格头部搜索组件
export { default as TableSearch } from './tableSearch/index';
// 表格头部搜索组件-小没有title
export { default as TableSearchSmall } from './tableSearch/small';
// 表格组件
export { default as StandardTable } from './standardTable/index';
// 上传图片（小图模式）
export { default as UploadImageSmall } from './uploadImage/small';
// 上传图片（困图模式）
export { default as UploadImage } from './uploadImage/index';
// 上传图片（头像模式）
export { default as UploadImageAvatar } from './uploadImage/avatar';
// 公用的方法
export { default as Utils } from './Utils/base';
// form表单的公用style样式
export { default as FormStyle } from './Utils/formStyle';
// 表格的公用方法
export { default as TableCommon } from './Utils/tableCommon';
// 验证的正则表达式
export { default as InputVerify } from './Utils/verify';
// 拖拽元素
export { default as Drag } from './Drag/index';
